<template>
  <base-material-card
    icon="mdi-account-arrow-left-outline"
    title="Users"
    class="px-5 py-3"
    style="position: relative"
  >
    <v-btn
      color="green"
      dark
      small
      absolute
      top
      right
      fab
      @click.stop="addDialog= true"
    >
      <v-icon>mdi-plus</v-icon>
    </v-btn>

    <v-row>
      <v-col
        cols="12"
        md="4"
      >
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Search by Name or Login"
          single-line
          hide-details
        />
      </v-col>
      <v-col
        cols="12"
        md="4"
      >
        <v-autocomplete
          v-model="selectedTeam"
          :items="teams"
          label="Filter by Team"
          item-text="name"
          item-value="code"
          clearable
          single-line
          hide-details
        />
      </v-col>
      <v-col
        cols="12"
        md="4"
      >
        <v-autocomplete
          v-model="selectedGroup"
          :items="groups"
          :label="'Filter by ' + groupLabel"
          item-text="name"
          item-value="code"
          clearable
          single-line
          hide-details
        />
      </v-col>
      <v-col
        cols="12"
        md="4"
      >
        <v-autocomplete
          v-model="selectedRoles"
          :items="roles"
          label="Filter by Roles"
          chips
          multiple
          clearable
          single-line
          hide-details
        />
      </v-col>
    </v-row>

    <v-row class="mt-2 mb-2">
      <v-col cols="auto">
        <v-btn
          color="success"
          @click="handleDownload"
        >
          Export to Excel
        </v-btn>
      </v-col>
    </v-row>

    <!-- Bulk action buttons -->
    <v-row
      v-if="tableSelected.length"
      style="padding: 20px"
    >
      <v-btn
        color="success"
        class="mr-2"
        @click="bulkSetActive(true)"
      >
        Set Active
      </v-btn>
      <v-btn
        color="warning"
        class="mr-2"
        @click="bulkSetActive(false)"
      >
        Set Inactive
      </v-btn>
      <v-btn
        v-if="$store.state.user && $store.state.user.name === 'Super'"
        color="error"
        @click="bulkDelete"
      >
        Delete Selected
      </v-btn>
    </v-row>

    <v-data-table
      v-model="tableSelected"
      :headers="headers"
      show-select
      item-value="id"
      :items="filteredUsers"
      :item-class="itemRowBackground"
    >
      <template
        v-slot:item.isActive="{ item }"
      >
        <v-chip
          :color="item.isActive !== false ? 'success' : 'grey'"
          small
          dark
        >
          {{ item.isActive !== false ? 'Active' : 'Inactive' }}
        </v-chip>
      </template>
      <template v-slot:item.groups="{ item }">
          <span v-for="(code, i) in (item.groups || [])" :key="i">
            {{ (groupMap[code] || code) }}<span v-if="i !== item.groups.length - 1">, </span>
          </span>
        </template>
      <template
        v-slot:item.action="{item}"
      >
        <Fragment>
          <v-icon

            medium
            @click="editItem(item)"
          >
            mdi-pencil
          </v-icon>
          <v-icon
            v-if="item.name === 'Super'"

            medium
            @click="deleteItem(item)"
          >
            mdi-delete
          </v-icon>
        </Fragment>
      </template>
    </v-data-table>

    <v-dialog
      v-model="addDialog"
      max-width="800"
      persistent
    >
      <v-card title="New User">
        <v-form
          ref="newItemForm"
          @submit.prevent="save(editedItem)"
        >
          <v-container>
            <v-card-text>
              <v-row>
                <v-col
                  cols="12"
                  md="6"
                >
                  <v-text-field
                    v-model="editedItem.name"
                    :rules="nameRules"
                    label="Name"
                  />
                </v-col>
                <v-col
                  cols="12"
                  md="6"
                >
                  <v-switch
                    v-model="editedItem.isActive"
                    label="Active"
                    :true-value="true"
                    :false-value="false"
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col
                  cols="12"
                  md="6"
                >
                  <v-text-field
                    v-model="editedItem.email"
                    :disabled="!!editedItem.id"
                    :rules="[() => !!editedItem.email || 'This field is required']"
                    label="Login"
                  />
                </v-col>
                <v-col
                  cols="12"
                  md="6"
                >
                  <v-text-field
                    v-model="editedItem.password"
                    :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                    :rules="[rules.required, rules.min]"
                    :type="show1 ? 'text' : 'password'"
                    name="input-10-1"
                    label="Password"
                    hint="At least 8 characters"
                    counter
                    @click:append="show1 = !show1"
                  />
                </v-col>
                <v-col
                  cols="12"
                  md="6"
                >
                  <v-text-field
                    v-model="editedItem.phoneNumber"
                    label="Phone"
                  />
                </v-col>
                <v-col
                  cols="12"
                  md="6"
                >
                  <v-text-field
                    v-model="editedItem.memberId"
                    label="Member ID"
                    disabled
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col
                  cols="12"
                  md="6"
                >
                  <v-autocomplete
                    v-model="editedItem.teams"
                    chips
                    clearable
                    multiple
                    small-chips
                    :items="teams"
                    label="Teams"
                    item-text="name"
                    item-value="code"
                  />
                </v-col>
                <v-col
                  cols="12"
                  md="6"
                >
                  <v-autocomplete
                    v-model="editedItem.currentTeam"

                    clearable

                    :items="teams"
                    label="Default Team"
                    item-text="name"
                    item-value="code"
                  />
                </v-col>
                <v-col
                  cols="12"
                  md="6"
                >
                  <v-autocomplete
                    v-model="editedItem.roles"
                    chips
                    clearable
                    multiple
                    small-chips
                    :items="roles"
                    label="Roles"
                  />
                </v-col>
                <v-col
                  cols="12"
                  md="6"
                >
                  <v-autocomplete
                    v-model="editedItem.groups"
                    chips
                    clearable
                    multiple
                    small-chips
                    :items="groups"
                    :label="groupLabelPlural"
                    item-text="name"
                    item-value="code"
                  />
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions>
              <v-spacer />
              <v-btn @click.stop="close">
                Cancel
              </v-btn>
              <v-btn
                color="primary"
                type="submit"
              >
                Save
              </v-btn>
            </v-card-actions>
          </v-container>
        </v-form>
      </v-card>
    </v-dialog>
  </base-material-card>
</template>

<script>
  import { mapGetters } from 'vuex'
  import _ from 'lodash'
  import { M_ADD_USER, M_CREATE_MANY_USERS, M_DELETE_USER, M_DELETE_USERS, M_UPDATE_USER, Q_GET_USERS } from '@/gql/user'
  import { Q_GET_GROUPS } from '@/gql/group'
  import { Q_GET_TEAMS } from '@/gql/team'
  export default {
    name: 'Users',
    data: () => ({
      show1: false,
      rules: {
        required: value => !!value || 'Required.',
        min: v => v.length >= 8 || 'Min 8 characters',
      },
      roles: ['editor', 'admin', 'head', 'supervisor', 'hr', 'super-admin', 'hr-head', 'member'],
      addDialog: false,
      editedIndex: -1,
      editedItem: { },
      defaultItem: { isActive: true },
      downloading: false,
      filename: '',
      bookType: 'xlsx',
      downloadLoading: false,
      autoWidth: true,
      search: '',
      selectedTeam: null,
      selectedGroup: null,
      selectedRoles: [],
      tableSelected: [],

    }),
    computed: {
      ...mapGetters([
        'team',
        'company',
        'teamFull',
        'companyFull',
        'groupLabel',
        'parentGroupLabel',
        'groupLabelPlural',
        'parentGroupLabelPlural',
      ]),
      headers () {
        return [
          // { text: 'ID', value: 'id' },
          { text: 'Name', value: 'name' },
          { text: 'Login', value: 'email' },
          { text: 'Phone', value: 'phoneNumber' },
          { text: 'Default Team', value: 'currentTeam' },
          { text: 'Roles', value: 'roles' },
          { text: 'Teams', value: 'teams' },
          { text: this.groupLabelPlural, value: 'groups' },
          { text: 'Status', value: 'isActive' },
          { text: 'Actions', value: 'action', sortable: false },
        ]
      },
      filteredUsers () {
        let users = this.users.filter(user => user.name !== 'Super')
        if (this.search) {
          const searchLower = this.search.toLowerCase()
          users = users.filter(user =>
            user.name.toLowerCase().includes(searchLower) ||
            user.email.toLowerCase().includes(searchLower),
          )
        }
        if (this.selectedTeam) {
          users = users.filter(user =>
            user.teams && user.teams.includes(this.selectedTeam),
          )
        }
        if (this.selectedGroup) {
          users = users.filter(user =>
            user.groups && user.groups.includes(this.selectedGroup),
          )
        }
        if (this.selectedRoles && this.selectedRoles.length) {
          users = users.filter(user =>
            user.roles && this.selectedRoles.every(role => user.roles.includes(role)),
          )
        } else {
          users = users.filter(user =>
            !(user.roles && user.roles.length === 1 && user.roles.includes('member')),
          )
        }
        return users
      },
      groupMap () {
        return (this.groups || []).reduce((acc, g) => {
          acc[g.code] = g.name
          return acc
        }, {})
      },
      maxSuperAdmins () {
        const limit = this.companyFull?.settings?.maxSuperAdmins
        return Number.isFinite(Number(limit)) && Number(limit) > 0 ? Number(limit) : null
      },
      currentSuperAdminCount () {
        return (this.users || []).filter(user =>
          user.name !== 'Super' &&
          Array.isArray(user.roles) &&
          user.roles.includes('super-admin'),
        ).length
      },
    },
    watch: {
      team: function () {
        this.editedItem = { currentTeam: this.team, isActive: true }
        this.defaultItem = { currentTeam: this.team, isActive: true }
      },
    },
    mounted () {
      this.editedItem = { currentTeam: this.team, isActive: true }
      this.defaultItem = { currentTeam: this.team, isActive: true }
    },
    methods: {
      hasSuperAdminRole (roles) {
        return Array.isArray(roles) && roles.includes('super-admin')
      },
      isReservedName (name) {
        return String(name || '').trim() === 'Super'
      },
      nameRules () {
        const rules = [() => !!this.editedItem.name || 'This field is required']
        if (this.editedIndex === -1) {
          rules.push(value => !this.isReservedName(value) || 'Super is a reserved name')
        }
        return rules
      },
      validateSuperAdminLimit () {
        if (!this.hasSuperAdminRole(this.editedItem.roles)) {
          return true
        }
        if (this.maxSuperAdmins === null) {
          return true
        }
        const currentRoles = this.editedIndex > -1 ? this.users[this.editedIndex]?.roles : []
        if (this.editedIndex > -1 && this.hasSuperAdminRole(currentRoles)) {
          return true
        }
        if (this.currentSuperAdminCount < this.maxSuperAdmins) {
          return true
        }
        this.$toast.error(`Super admin limit is ${this.maxSuperAdmins}`)
        return false
      },
      handleDownload () {
        this.downloadLoading = true
        this.filename = `Tik Users ${this.company} ${this.teamFull && this.teamFull.name}`
        import('@/vendor/Export2Excel').then(excel => {
          const tHeader = ['CurrentTeam', 'Name', 'Login', 'Phone', 'Roles', 'Teams', this.groupLabelPlural, 'Status']
          const list = _.orderBy(this.filteredUsers, ['currentTeam', 'name', 'email'], ['asc', 'asc', 'asc'])
          const data = this.formatJson(['currentTeam', 'name', 'email', 'phoneNumber', 'roles', 'teams', 'groups', 'isActive'], list)
          excel.export_json_to_excel({
            header: tHeader,
            data,
            filename: this.filename,
            autoWidth: this.autoWidth,
            bookType: this.bookType,
          })
          this.downloadLoading = false
        }).catch((error) => {
          console.error(error)
          this.downloadLoading = false
        })
      },
      formatJson (filterVal, jsonData) {
        return jsonData.map(v => filterVal.map(j => {
          if (typeof v[j] === 'number') {
            return +v[j].toFixed(1)
          }

          return v[j]
        }))
      },
      itemRowBackground: function (item) {
        return item.isActive === false ? 'inactive' : ''
      },
      handleUploadSuccess ({ results, header }) {
        const okResults = results.map(r => _.pick(r, ['name', 'code', 'currentTeam']))
        this.createUsers(okResults)
      },
      beforeUpload (file) {
        const isLt1M = file.size / 1024 / 1024 < 1

        if (isLt1M) {
          return true
        }
      },
      bulkSetActive (isActive) {
        const updates = this.tableSelected.map(item => ({
          id: item.id,
          isActive,
        }))
        Promise.all(
          updates.map(update => this.update(update)),
        ).then(() => {
          this.$toast.info(`Set ${isActive ? 'active' : 'inactive'} for ${updates.length} users`)
          this.tableSelected = []
        }).catch(error => {
          this.$toast.error('Failed to update users')
          console.error(error)
        })
      },
      bulkDelete () {
        if (!confirm(`Are you sure you want to delete ${this.tableSelected.length} users?`)) {
          return
        }
        const ids = this.tableSelected.map(item => +item.id)
        this.$apollo.mutate({
          mutation: M_DELETE_USERS,
          variables: { ids },
          update: (store, { data: { deleteUsers } }) => {
            const data = store.readQuery({ query: Q_GET_USERS })
            data.users = data.users.filter(u => !ids.includes(+u.id))
            store.writeQuery({ query: Q_GET_USERS, data })
          },
        }).then(() => {
          this.$toast.info(`Deleted ${ids.length} users`)
          this.tableSelected = []
        }).catch(error => {
          console.error(error)
          this.$toast.error('Failed to delete users')
        })
      },
      createMany (records) {
        this.$apollo.mutate({
          mutation: M_CREATE_MANY_USERS,
          // Parameters
          variables: {
            records,
          },
          update: (store, { data: { createUsers } }) => {
            // Read the data from our cache for this query.
            const data = store.readQuery({
              query: Q_GET_USERS,
            })
            // Add our tag from the mutation to the end
            data.users.push(...createUsers)
            // Write our data back to the cache.
            store.writeQuery({
              query: Q_GET_USERS,
              data,
            })
          },
          // Optimistic UI
          // Will be treated as a 'fake' result as soon as the request is made
          // so that the UI can react quickly and the user be happy
          optimisticResponse: {
            __typename: 'Mutation',
            createUsers: {
              records,
            },
          },
        }).then((data) => {
          this.$toast.info(`${records.length} New Items Added`)
        }).catch((error) => {
          // Error
          console.error(error)
          this.$toast.error('Something went wrong when add new items')
        })
      },
      createOne (item) {
        this.$apollo.mutate({
          mutation: M_ADD_USER,
          // Parameters
          variables: item,
          update: (store, { data: { createUser } }) => {
            const data = store.readQuery({
              query: Q_GET_USERS,
            })

            data.users = [...data.users, createUser]

            store.writeQuery({
              query: Q_GET_USERS,
              data,
            })
          },

          optimisticResponse: {
            __typename: 'Mutation',
            createUser: {
              id: 9999,
              code: ' ',
              currentTeam: this.team,
              isActive: true,
              ...item,
              __typename: 'User',
            },
          },
        }).then((data) => {
          this.$toast.info('New Record Added')
        }).catch((error) => {
          // Error
          console.error(error)
          this.$toast.error('Something went wrong when adding a record')
        })
      },
      update (item) {
        item.id = +item.id
        this.$apollo.mutate({
          mutation: M_UPDATE_USER,
          variables: item,
          update: (store, { data: { updateUser } }) => {
            if (updateUser) {
              // Read the data from our cache for this query.
              const data = store.readQuery({
                query: Q_GET_USERS,
              })

              const itemX = data.users.find(t => +t.id === updateUser.id)

              for (const key of Object.keys(updateUser)) {
                itemX[key] = updateUser[key]
              }

              store.writeQuery({
                query: Q_GET_USERS,
                data,
              })
            }
          },
          optimisticResponse: {
            __typename: 'Mutation',
            updateUser: {
              __typename: 'User',
              ...item,
            },
          },

        }).then(d => {
          this.$toast.info('Record Updated')
        }).catch((error) => {
          console.error(error)
          this.$toast.error('Sorry,failed to update the record')
        })
      },
      deleteOne (id) {
        this.$apollo.mutate({
          mutation: M_DELETE_USER,
          variables: {
            where: { id },
          },
          update: (store, { data: { deleteUser } }) => {
            const data = store.readQuery({
              query: Q_GET_USERS,
            })
            data.users = data.users.filter(t => {
              return +t.id !== id
            })
            store.writeQuery({
              query: Q_GET_USERS,
              data,
            })
          },
          optimisticResponse: {
            __typename: 'Mutation',
            deleteUser: {
              id,
            },
          },
        },
        ).then(() => {
          this.$toast.info('Record Deleted')
        }).catch((error) => {
          console.error(error)
          this.$toast.error('Sorry, failed to delete the record')
        })
      },
      close () {
        this.addDialog = false
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        }, 300)
      },
      editItem (item) {
        this.editedIndex = this.users.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.addDialog = true
      },
      deleteItem (item) {
        confirm('Are you sure you want to delete this item?') && this.deleteOne(+item.id)
      },
      save (item) {
        if (this.editedIndex === -1 && this.isReservedName(item.name)) {
          this.$toast.error('Super is a reserved name')
          return
        }
        if (!this.validateSuperAdminLimit()) {
          return
        }
        this.close()
        if (this.editedIndex > -1) {
          this.update(item)
        } else {
          this.createOne(item)
        }
      },

    },
    apollo: {
      users: {
        query: Q_GET_USERS,
      },
      teams: {
        query: Q_GET_TEAMS,
      },
      groups: {
        query: Q_GET_GROUPS,
      },

    },

  }
</script>

<style   >
.inactive {
  /*background-color: rgb(215,215,44);*/
  text-decoration: line-through !important;
}
</style>
